import React from 'react';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';

export default function Reports() {
  return (
    <div>
      <PageHeader icon={Icon.reports} title="Reports" subtitle="Revenue, on-time performance, driver reports" color={SECTION_COLOR.reports} />
      <p className="empty">Reports will live here. Coming soon.</p>
    </div>
  );
}
